import { useMemo, useState } from 'react';

import { FILTER_SNIPPET_ITEMS } from '../../../entities/snippets';

import { SORT_ITEMS } from '../lib/config';
import { ALL_OWNERS } from '../../../features/team-members';

export const useSnippetsFilters = () => {
  const [filterByOwner, setFilterByOwner] = useState(ALL_OWNERS);
  const [filter, setFilter] =
    useState<keyof typeof FILTER_SNIPPET_ITEMS>('allTypes');
  const [sort, setSort] = useState<keyof typeof SORT_ITEMS>('lastCreated');

  const isFiltersActive = useMemo(() => {
    return filterByOwner !== ALL_OWNERS || filter !== 'allTypes';
  }, [filterByOwner, filter]);

  return {
    filterByOwner,
    filter,
    sort,
    setFilterByOwner,
    setFilter,
    setSort,
    isFiltersActive,
  };
};
